module.exports = __webpack_public_path__ + "img/sintesis.f91a9e63.svg";